module.exports = __webpack_public_path__ + "static/media/IconDeleteFilter.bd407187.svg";